import {
  App,
  areAppsEquivalent,
  areFENummerEqual,
  FremdVNVorvertrag,
  VnWechselAngaben,
} from '@ps20-frontend/frontend-models';
import { AddVertragToAngebote, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { IAppState } from '../appState';

function normalizeToVwgV2(vnWechselAngaben: VnWechselAngaben): VnWechselAngaben {
  return {
    ...vnWechselAngaben,
    angabenListe: vnWechselAngaben.angabenListe?.map(element => ({
      ...element,
      fremdVNVorvertraege: element.fremdVNVorvertraege?.map(vorvertrag => ({
        ...vorvertrag,
        vorvertragsnummer: {
          ...vorvertrag.vorvertragsnummer,
          produktIds: vorvertrag.vorvertragsnummer?.produktIds?.map(id =>
            areAppsEquivalent(id, App.VWG_V2) ? App.VWG_V2 : id,
          ),
        },
        vnWechselGrund: vorvertrag.vnWechselGrund?.map(grund => ({
          ...grund,
          appId: areAppsEquivalent(grund.appId, App.VWG_V2) ? App.VWG_V2 : grund.appId,
        })),
      })),
    })),
  };
}

export const vnWechselAngabenReducer = function (
  sectionState: VnWechselAngaben = null,
  action: AnyAction,
  state: IAppState,
): VnWechselAngaben {
  switch (action.type) {
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      const actionPayload: AddVertragToAngebote = action.payload;
      if (
        actionPayload.appId === App.VWG_V2 &&
        actionPayload.angebotsId === state.angebotsId &&
        actionPayload.vnWechselAngaben
      ) {
        return normalizeToVwgV2(actionPayload.vnWechselAngaben);
      }
      return sectionState;
    }
    case GlobalActions.VN_WECHSEL_GRUND_CHANGED: {
      const payload: FremdVNVorvertrag = action.payload;
      if (payload.vnWechselGrund.every(value => areAppsEquivalent(value.appId, App.VWG_V2))) {
        const found: FremdVNVorvertrag = sectionState.angabenListe
          ?.reduce((acc, angabe) => acc.concat(angabe.fremdVNVorvertraege), [])
          .find(fremdVNVorvertrag =>
            areFENummerEqual(fremdVNVorvertrag.vorvertragsnummer, payload.vorvertragsnummer),
          );
        if (found) {
          found.vnWechselGrund = payload.vnWechselGrund.map(grund => ({
            ...grund,
            appId: App.VWG_V2,
          }));
        }
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
